module.exports = __webpack_public_path__ + "media/images/slider-text-bg@3x-ff034c9cfa1f8ffd0467427a32a35dc6.png";